import { Navigate } from "@tanstack/react-router";
import logo from "@/assets/aihr-logo.png";
import { CosmosBackdrop } from "@/components/auth/CosmosBackdrop";
import { useAihrAuth } from "@/lib/auth/useAihrAuth";

function GoogleGlyph() {
  return (
    <svg
      className="auth-google-icon"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.71-1.57 2.68-3.88 2.68-6.62z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.47-.81 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.32A9 9 0 0 0 9 18z"
      />
      <path
        fill="#FBBC05"
        d="M3.97 10.72A5.4 5.4 0 0 1 3.68 9c0-.6.1-1.18.29-1.72V4.96H.96A9 9 0 0 0 0 9c0 1.45.35 2.83.96 4.04l3.01-2.32z"
      />
      <path
        fill="#EA4335"
        d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.89 11.43 0 9 0A9 9 0 0 0 .96 4.96l3.01 2.32C4.68 5.16 6.66 3.58 9 3.58z"
      />
    </svg>
  );
}

export function SigninPage() {
  const auth = useAihrAuth();

  if (auth.isAuthenticated && !auth.isLoading) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="auth-split">
      <section className="auth-pane auth-pane--form">
        <header className="auth-brand">
          <img src={logo} alt="AIHR" className="auth-brand-mark" />
          <div className="auth-brand-text">
            <span className="auth-brand-name">AIHR</span>
            <span className="auth-brand-product">Cosmos</span>
          </div>
        </header>

        <div className="auth-form">
          <div className="auth-form-heading">
            <span className="auth-eyebrow">Internal workspace</span>
            <h1>Hi there, welcome to Cosmos.</h1>
            <p>
              {auth.authEnabled
                ? "Sign in with your AIHR Google account to explore course intelligence, journeys, and the data that powers it all."
                : "Continue in local header mode to explore course intelligence, journeys, and the data that powers it all."}
            </p>
          </div>

          <button
            type="button"
            className="auth-google-button"
            onClick={() => void auth.login()}
            disabled={auth.isLoading}
          >
            {auth.authEnabled && <GoogleGlyph />}
            <span>
              {auth.isLoading
                ? "Opening Google..."
                : auth.authEnabled
                  ? "Continue with Google"
                  : "Continue in local mode"}
            </span>
          </button>

          <div className="auth-divider">
            <span>Restricted access</span>
          </div>

          <p className="auth-helper">
            Cosmos is only available to AIHR teammates with the{" "}
            <code>cosmos</code> role. Need access?{" "}
            <a
              className="auth-link"
              href="mailto:platform@aihr.com?subject=Cosmos%20access%20request"
            >
              Contact the Platform team
            </a>
            .
          </p>
        </div>

        <footer className="auth-footer">
          <span>© {new Date().getFullYear()} AIHR · Cosmos runtime</span>
          <a href="https://www.aihr.com" target="_blank" rel="noreferrer">
            aihr.com
          </a>
        </footer>
      </section>

      <section className="auth-pane auth-pane--cosmos">
        <CosmosBackdrop />
      </section>
    </div>
  );
}
